app.views.home = app.views.base.extend({
  init: function init(data) {
    this._initPostMessageEventListener();
  },
  _initPostMessageEventListener: function _initPostMessageEventListener() {
    var $login = $('#Login');
    window.addEventListener('message', function (event) {
      if (event.origin === $login.data('origin') && event.data.type === 'resize') {
        var $iFrame = $('#LoginIFrame');
        if (!$iFrame) return;
        $iFrame.css('height', event.data.height);
      }
      if (event.origin === $login.data('origin') && event.data.type === 'redirect') {
        var _$iFrame = $('#LoginIFrame');
        if (!_$iFrame) return;
        window.location = event.data.url;
      }
    });
  }
});